/* eslint-disable */
import * as dayjs from 'dayjs'
import i18n from '@/lang'

export function convertToVerticalList(list, headerList, idHeader) {
  const result = [] // [{ 'id': 31, 'name': 'a', 'email': '', 'note': null, 'no': '1', 'create_date': null, 'create_user_id': 0, 'modify_date': null, 'modify_user_id': 0, 'profile_code': 'a', 'invoice_agent_name': 'a', 'profile_type': 0, 'phone_1': '', 'phone_2': '', 'address_1': 'a1111', 'address_2': 'a', 'business_code': null, 'tax_code': null, 'bank_number': '13123', 'bank_name': 'a', 'nation_id': null, 'state_name': null, 'city_name': null, 'zip_code': null, 'representative_name': null, 'representative_email': null, 'representative_number_phone_1': null, 'representative_number_phone_2': null, 'representative_birthday': null, 'representative_id_card': null, 'representative_card_date': null, 'representative_card_place': null, 'market_seg_id': 1, 'business_person_id': 20194224, 'source_id': null, 'business_seg_id': null, 'other_infor': null, 'market_seg_name': null, 'business_man_name': null }, { 'id': 33, 'name': 'das', 'email': '', 'note': null, 'no': '2', 'create_date': null, 'create_user_id': 0, 'modify_date': null, 'modify_user_id': 0, 'profile_code': 'bienld', 'invoice_agent_name': 'das', 'profile_type': 0, 'phone_1': '', 'phone_2': '', 'address_1': 'bn', 'address_2': 'bn', 'business_code': null, 'tax_code': null, 'bank_number': '123456789', 'bank_name': 'acb', 'nation_id': null, 'state_name': null, 'city_name': null, 'zip_code': null, 'representative_name': null, 'representative_email': null, 'representative_number_phone_1': null, 'representative_number_phone_2': null, 'representative_birthday': null, 'representative_id_card': null, 'representative_card_date': null, 'representative_card_place': null, 'market_seg_id': 1, 'business_person_id': 20231010, 'source_id': null, 'business_seg_id': null, 'other_infor': null, 'market_seg_name': null, 'business_man_name': null }, { 'id': 32, 'name': 'bienle', 'email': '', 'note': null, 'no': '3', 'create_date': null, 'create_user_id': 0, 'modify_date': null, 'modify_user_id': 0, 'profile_code': 'bienle', 'invoice_agent_name': 'bienle', 'profile_type': 0, 'phone_1': '', 'phone_2': '', 'address_1': 'bienle', 'address_2': 'bienle', 'business_code': null, 'tax_code': null, 'bank_number': 'bienle', 'bank_name': 'bienle', 'nation_id': null, 'state_name': null, 'city_name': null, 'zip_code': null, 'representative_name': null, 'representative_email': null, 'representative_number_phone_1': null, 'representative_number_phone_2': null, 'representative_birthday': null, 'representative_id_card': null, 'representative_card_date': null, 'representative_card_place': null, 'market_seg_id': 2, 'business_person_id': 20194224, 'source_id': null, 'business_seg_id': null, 'other_infor': null, 'market_seg_name': null, 'business_man_name': null }]

  const header =
    headerList?.length > 0
      ? [...headerList]
      : [
          {
            value: 'profile_code',
            text: i18n.t('config.profile.field.profileCode')
          },
          { value: 'name', text: i18n.t('config.profile.field.name') },
          {
            value: 'invoice_agent_name',
            text: i18n.t('config.profile.field.invoiceAgentName')
          },
          {
            value: 'profile_type',
            text: i18n.t('config.profile.field.profileType')
          },
          {
            value: 'business_code',
            text: i18n.t('config.profile.field.businessCode')
          },
          {
            value: 'market_seg_id',
            text: i18n.t('config.profile.field.marketSegName')
          },
          {
            value: 'source_id',
            text: i18n.t('config.profile.field.source')
          },
          {
            value: 'tax_code',
            text: i18n.t('config.profile.field.taxCode')
          },
          {
            value: 'bank_name',
            text: i18n.t('config.profile.field.bankName')
          },
          {
            value: 'bank_number',
            text: i18n.t('config.profile.field.bankNumber')
          },
          {
            value: 'business_person_id',
            text: i18n.t('config.profile.field.businessManName')
          },
          {
            value: 'address_1',
            text: i18n.t('config.profile.field.address1')
          },
          {
            value: 'address_2',
            text: i18n.t('config.profile.field.address2')
          },
          {
            value: 'nation_id',
            text: i18n.t('config.profile.field.nation')
          },
          {
            value: 'state_name',
            text: i18n.t('config.profile.field.state')
          },
          {
            value: 'city_name',
            text: i18n.t('config.profile.field.city')
          },
          {
            value: 'zip_code',
            text: i18n.t('config.profile.field.zipCode')
          },
          { value: 'email', text: i18n.t('config.profile.field.email') },
          {
            value: 'phone_1',
            text: i18n.t('config.profile.field.phone1')
          },
          {
            value: 'phone_2',
            text: i18n.t('config.profile.field.phone2')
          },
          {
            value: 'representative_name',
            text: i18n.t('config.profile.field.repName')
          },
          {
            value: 'representative_email',
            text: i18n.t('config.profile.field.repEmail')
          },
          {
            value: 'representative_number_phone_1',
            text: i18n.t('config.profile.field.repPhone1')
          },
          {
            value: 'representative_number_phone_2',
            text: i18n.t('config.profile.field.repPhone2')
          },
          {
            value: 'representative_birthday',
            text: i18n.t('config.profile.field.repBirth')
          },
          {
            value: 'representative_id_card',
            text: i18n.t('config.profile.field.repIdCard')
          },
          {
            value: 'representative_card_date',
            text: i18n.t('config.profile.field.repIdCardDate')
          }
        ]

  const id = idHeader || 'profile_code'

  header.forEach((field, index) => {
    const item = new Map() // using map to preserve the order of property: field > result > profile
    item.set('field', field)
    item.set('result', null)
    item.set('selectedField', null)
    list.forEach((data, jndex) => {
      item.set(data[id], data[field.value])
    })
    // const item = Object.assign({}, {
    //   field: field,
    //   result: null
    // })
    // list.forEach((data, jndex) => {
    //   item[data[id]] = data[field.value]
    // })
    result.push(item)
  })

  return result
}

export function convertToVerticalGroupList(list, headerList, idHeader) {
  const result = []
  const header = [...headerList]

  const id = idHeader || 'profile_code'

  header.forEach((field, index) => {
    const item = new Map() // using map to preserve the order of property: field > result > profile
    item.set('field', field)
    item.set('result', null)
    item.set('selectedField', null)
    list.forEach((data, jndex) => {
      item.set(data[id], data[field.value])
    })
    // const item = Object.assign({}, {
    //   field: field,
    //   result: null
    // })
    // list.forEach((data, jndex) => {
    //   item[data[id]] = data[field.value]
    // })
    result.push(item)
  })

  return result
}

export function convertToHorizontalObj(list, resultTemplate) {
  const result = resultTemplate
    ? { ...resultTemplate }
    : {
        name: null,
        email: null,
        note: null,
        profile_code: null,
        invoice_agent_name: null,
        profile_type: 0,
        phone_1: null,
        phone_2: null,
        address_1: null,
        address_2: null,
        business_code: null,
        tax_code: null,
        bank_number: null,
        bank_name: null,
        nation_id: 0,
        state_name: null,
        city_name: null,
        zip_code: null,
        representative_name: null,
        representative_email: null,
        representative_number_phone_1: null,
        representative_number_phone_2: null,
        representative_birthday: null,
        representative_id_card: null,
        representative_card_date: null,
        representative_card_place: null,
        market_seg_id: 0,
        business_person_id: null,
        source_id: 0,
        business_seg_id: 0,
        other_infor: false,
        contact_list: [
          // {
          //   name: null,
          //   position: null,
          //   email: null,
          //   note: null,
          //   phone_number_1: null,
          //   phone_number_2: null
          // }
        ],
        agent_debit_list: [
          // {
          //   agent_id: null,
          //   hotel_id: null,
          //   debit_account_id: null,
          //   debit_account_name: null,
          //   main_account: null
          // }
        ]
      }
  list.forEach((map, index) => {
    result[map.get('field').value] = map.get('result')
  })
  return result
}

export function paddingZero(number, unit) {
  switch (unit) {
    case 'D':
    case 'M':
    case 'h':
    case 'm':
      if (number < 10) return String(number).padStart(2, '0')
      else return String(number)

    case 'y':
      if (String(number).length < 4) return String(dayjs().get('y'))
      else return String(number)
  }
}
